import {useState} from "react";
import {Link} from "react-router-dom";

const MenuSublist = (props) => {
    const [isClicked, setIsClicked] = useState(true);

    const openSubMenu = () => {
        setIsClicked(!isClicked);
        isClicked ? props.setItemtClass("menu__items _active") : props.setItemtClass("menu__items")
    }

    return (<><span className="menu__arrow" onClick={openSubMenu}></span>
        <ul className="menu__sublist">
            <li className="menu__subitems"><Link to="categories/linens" className="menu__sublink">Постельное
                белье</Link></li>
            <li className="menu__subitems"><Link to="categories/blankets"
                                                 className="menu__sublink">Одеяла</Link>
            </li>
            <li className="menu__subitems"><Link to="categories/blankets"
                                                 className="menu__sublink">Пледы</Link>
            </li>
            <li className="menu__subitems"><Link to="categories/terry" className="menu__sublink">Махровые
                изделия</Link></li>
            <li className="menu__subitems"><Link to="categories/for-childrens" className="menu__sublink">Детский
                текстиль</Link></li>
        </ul>
    </>);

}
export default MenuSublist;